import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function quizcategoryListReducer(
  state = initialState.quizcategoryList,
  action
) {
  switch (action.type) {
    case types.LOADED_QUIZ_CATEGORY_LIST_SUCCESS:
      return action.quizcategoryList;
    default:
      return state;
  }
}
